import React, { useEffect, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { ProductIntro } from './components/ProductIntro';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UpsellSection } from './components/UpsellSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
import { LazySection } from './components/ui/LazySection';
export function App() {
  useEffect(() => {
    // === 1. SEO META TAGS (lightweight, no external requests) ===
    document.documentElement.lang = 'es';
    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };
    document.title = 'Master Pack Reparación Express — Monopatines Eléctricos | Fegion';
    setMeta('description', 'Sistema completo de diagnóstico y reparación para monopatines eléctricos. 5 Tomos + 2 Bonos. Resolvé cualquier falla en 5 minutos sin depender del service. Garantía 7 días.');
    setMeta('robots', 'index, follow');
    setMeta('og:title', 'Master Pack Reparación Express — Monopatines Eléctricos', true);
    setMeta('og:description', 'El sistema de los 5 protocolos para diagnosticar y reparar tu monopatín eléctrico. Acceso inmediato. Garantía 7 días.', true);
    setMeta('og:type', 'product', true);
    setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/2oMb5AVTctNw69Kf1Y1zf5/acostsdo.png', true);
    setMeta('og:locale', 'es_AR', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Master Pack Reparación Express — Monopatines Eléctricos');
    setMeta('twitter:description', 'Sistema completo de diagnóstico y reparación. 5 Tomos + 2 Bonos. Resolvé cualquier falla en 5 minutos.');
    setMeta('twitter:image', 'https://cdn.magicpatterns.com/uploads/2oMb5AVTctNw69Kf1Y1zf5/acostsdo.png');
    // JSON-LD
    if (!document.querySelector('script[type="application/ld+json"]')) {
      const jsonLd = document.createElement('script');
      jsonLd.type = 'application/ld+json';
      jsonLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Master Pack: Reparación Express',
        description: 'Sistema completo de diagnóstico y reparación para monopatines eléctricos. 5 Tomos + 2 Bonos.',
        image: 'https://cdn.magicpatterns.com/uploads/2oMb5AVTctNw69Kf1Y1zf5/acostsdo.png',
        brand: {
          '@type': 'Brand',
          name: 'Fegion'
        },
        offers: [{
          '@type': 'Offer',
          name: 'Master Pack Completo',
          price: '29990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://fegion.shop/cart/46210825814155:1'
        }, {
          '@type': 'Offer',
          name: 'Pack Base',
          price: '19990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://fegion.shop/cart/46210815328395:1'
        }],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5',
          reviewCount: '5'
        }
      });
      document.head.appendChild(jsonLd);
    }
    // === 2. GOOGLE FONTS — load AFTER LCP (3s delay) ===
    // This removes fonts from the critical rendering path entirely
    const loadFonts = () => {
      if (document.querySelector('link[href*="fonts.googleapis.com/css2"]')) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Oswald:wght@500;700&display=swap';
      document.head.appendChild(link);
    };
    setTimeout(loadFonts, 3000);
    // === 3. META PIXEL — heavily deferred ===
    const initPixel = () => {
      const pixelId = '904978025482552';
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.alt = '';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      document.body.appendChild(img);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => setTimeout(initPixel, 1000));
    } else {
      setTimeout(initPixel, 4000);
    }
  }, []);
  return <main className="min-h-screen bg-brand-dark text-zinc-300 font-sans selection:bg-brand-red/30 selection:text-red-200" data-id="element-0">
      {/* Above-fold ONLY: hero renders immediately */}
      <HeroSection data-id="element-1" />

      {/* Everything else lazy-loaded */}
      <LazySection minHeight="600px" data-id="element-2">
        <ProblemSection data-id="element-3" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-4">
        <TruthSection data-id="element-5" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-6">
        <ProductIntro data-id="element-7" />
      </LazySection>
      <LazySection minHeight="600px" data-id="element-8">
        <TomosSection data-id="element-9" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-10">
        <BonusSection data-id="element-11" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-12">
        <ComparisonTable data-id="element-13" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-14">
        <TestimonialsSection data-id="element-15" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-16">
        <UpsellSection data-id="element-17" />
      </LazySection>
      <LazySection minHeight="500px" data-id="element-18">
        <PricingSection data-id="element-19" />
      </LazySection>
      <LazySection minHeight="400px" data-id="element-20">
        <FinalCTA data-id="element-21" />
      </LazySection>
      <LazySection minHeight="200px" data-id="element-22">
        <GuaranteeSection data-id="element-23" />
      </LazySection>
      <LazySection minHeight="100px" data-id="element-24">
        <Footer data-id="element-25" />
      </LazySection>
    </main>;
}